import request from "@/util/request.js";
export const getlifeLogOut = (params) =>
  request({
    url: "/wms/wx/officialAccount/wcl/snLifeLogOut",
    method: "GET",
    params,
  });
